import { network } from 'services/network';

export const uploadDataStory = (params) => {
    const formData = new FormData();
    if (params.file !== null) {
        if (typeof params.file.size !== 'undefined') {
            formData.append('file', params.file, params.file.name);
        }
    }
    formData.append(
        'request',
        JSON.stringify({
            id: params.id,
            projectId: params.projectId,
            contractId: params.contractId,
            contractName: params.contractName,
            title: params.title,
            description: params.description,
            mentionedList: params.mentionedList,
            tagList: params.tagList,
            embeddedCode: params.embeddedCode,
            createdDate: params.createdDate,
        }),
    );

    return network
        .post('api/bo/project/uploadDataStory', formData, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then((response) => {
            return response.data;
        });
};
